function transZhEnDynamic(title){
  let str = 'common.'+title;
  return this.$t(str);
}
export {transZhEnDynamic}